export { Button } from './components/buttton';
export { CheckBox } from './components/checkbox';
export { Input } from './components/input';
export { TextArea } from './components/textarea';
export { Select, Creatable, AsyncSelect } from './components/select';
export { Modal, ModalConfirmTyping } from './components/modal';
export { Avatar } from './components/avatar';
export { Radio } from './components/radio';
export { Switch } from './components/switch';
export { Card, CardContent, CardHeader, CardFooter } from './components/card';
export { Table } from './components/table';
export { Image } from './components/image';
export { ClickOutside } from './components/clickoutside';
export { Skeleton } from './components/skeleton';
export { Stepper } from './components/stepper';
export { Collapse } from './components/collapse';
export { CurrencyInput } from './components/currency/';

// @types
export { ButtonSize } from './components/buttton/styles';
export { ModalPosition } from './components/modal';

export enum Colors {
    DANGER = '#dc3545',
    ALERT = '#ffd14d',
    PRIMARY = '#47516f',
    SUCCESS = '#2d694d',
}
